module.exports = __webpack_public_path__ + "static/media/andre-carvalho-k_mLEqWmZug-unsplash.9a7fc848.png";